import { BaseBody } from '../BaseBody.js';
import { CssVars } from '../../../util/CssVars.js';

const glyphname = 'petastiYporroi';
const args = {};

export class PetastiYporroi extends BaseBody {
  constructor() {
    super(glyphname, args);
  }
}
